import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GridstackModule } from 'gridstack/dist/angular';

import { MaterialModule } from '../../material.module';

import { DynamicContainerComponent } from './components/dynamic-container/dynamic-container.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { WidgetContainerSkeletonComponent } from './components/widget-container/wdiget-container-skeleton/widget-container-skeleton.component';
import { WidgetContainerComponent } from './components/widget-container/widget-container.component';
import { WidgetMenuComponent } from './components/widget-menu/widget-menu.component';
import { WidgetPanelComponent } from './components/widget-panel/widget-panel.component';
import { BarChartSkeletonComponent } from './components/widgets/bar-chart.component/bar-chart-skeleton/bar-chart-skeleton.component';
import { BarChartComponent } from './components/widgets/bar-chart.component/bar-chart.component';
import { CountWidgetSkeletonComponent } from './components/widgets/count-widget/count-widget-skeleton/count-widget-skeleton.component';
import { CountWidgetComponent } from './components/widgets/count-widget/count-widget.component';
import { DonutWidgetSkeletonComponent } from './components/widgets/donut-widget/donut-widget-skeleton/donut-widget-skeleton.component';
import { DonutWidgetComponent } from './components/widgets/donut-widget/donut-widget.component';
import { GroupBarChartSkeletonComponent } from './components/widgets/group-bar-chart/group-bar-chart-skeleton/group-bar-chart-skeleton.component';
import { GroupBarChartComponent } from './components/widgets/group-bar-chart/group-bar-chart.component';
import { LineChartSkeletonComponent } from './components/widgets/line-chart/line-chart-skeleton/line-chart-skeleton.component';
import { LineChartComponent } from './components/widgets/line-chart/line-chart.component';
import { NumberCardWidgetSkeletonComponent } from './components/widgets/number-card-widget/number-card-widget-skeleton/number-card-widget-skeleton.component';
import { NumberCardWidgetComponent } from './components/widgets/number-card-widget/number-card-widget.component';
import { ProgressBarWidgetSkeletonComponent } from './components/widgets/progress-bar-widget/progress-bar-widget-skeleton/progress-bar-widget-skeleton.component';
import { ProgressBarWidgetComponent } from './components/widgets/progress-bar-widget/progress-bar-widget.component';

@NgModule({
  imports: [
    GridstackModule,
    CommonModule,
    MaterialModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    LayoutModule,
    TranslateModule,
    FormsModule,
    NgxChartsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    DynamicContainerComponent,
    MenuItemComponent,
    WidgetContainerSkeletonComponent,
    WidgetContainerComponent,
    WidgetMenuComponent,
    WidgetPanelComponent,
    BarChartSkeletonComponent,
    BarChartComponent,
    CountWidgetSkeletonComponent,
    CountWidgetComponent,
    DonutWidgetSkeletonComponent,
    DonutWidgetComponent,
    GroupBarChartSkeletonComponent,
    GroupBarChartComponent,
    LineChartSkeletonComponent,
    LineChartComponent,
    NumberCardWidgetSkeletonComponent,
    NumberCardWidgetComponent,
    ProgressBarWidgetSkeletonComponent,
    ProgressBarWidgetComponent,
  ],
  exports: [
    DynamicContainerComponent,
    MenuItemComponent,
    WidgetContainerSkeletonComponent,
    WidgetContainerComponent,
    WidgetMenuComponent,
    WidgetPanelComponent,
    BarChartSkeletonComponent,
    BarChartComponent,
    CountWidgetSkeletonComponent,
    CountWidgetComponent,
    DonutWidgetSkeletonComponent,
    DonutWidgetComponent,
    GroupBarChartSkeletonComponent,
    GroupBarChartComponent,
    LineChartSkeletonComponent,
    LineChartComponent,
    NumberCardWidgetSkeletonComponent,
    NumberCardWidgetComponent,
    ProgressBarWidgetSkeletonComponent,
    ProgressBarWidgetComponent,
  ],
  providers: [],
})
export class WidgetModule {}

export * from './components/dynamic-container/dynamic-container.component';
export * from './components/menu-item/menu-item.component';
export * from './components/widget-container/wdiget-container-skeleton/widget-container-skeleton.component';
export * from './components/widget-container/widget-container.component';
export * from './components/widget-menu/widget-menu.component';
export * from './components/widget-panel/widget-panel.component';
export * from './components/widgets/bar-chart.component/bar-chart.component';
export * from './components/widgets/bar-chart.component/bar-chart-skeleton/bar-chart-skeleton.component';
export * from './components/widgets/count-widget/count-widget.component';
export * from './components/widgets/count-widget/count-widget-skeleton/count-widget-skeleton.component';
export * from './components/widgets/donut-widget/donut-widget.component';
export * from './components/widgets/donut-widget/donut-widget-skeleton/donut-widget-skeleton.component';
export * from './components/widgets/group-bar-chart/group-bar-chart.component';
export * from './components/widgets/group-bar-chart/group-bar-chart-skeleton/group-bar-chart-skeleton.component';
export * from './components/widgets/line-chart/line-chart.component';
export * from './components/widgets/line-chart/line-chart-skeleton/line-chart-skeleton.component';
export * from './components/widgets/number-card-widget/number-card-widget.component';
export * from './components/widgets/number-card-widget/number-card-widget-skeleton/number-card-widget-skeleton.component';
export * from './components/widgets/progress-bar-widget/progress-bar-widget.component';
export * from './components/widgets/progress-bar-widget/progress-bar-widget-skeleton/progress-bar-widget-skeleton.component';
